import HandoutsFeatureComponent from './HandoutsFeatureComponent/HandoutsFeatureComponent'

export default HandoutsFeatureComponent
